import { request } from "@/interface/helper";

const str = "settingRole";

export const settingRole = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/role/list" }),
    add: (data) => request({ data, method: "post", url: "/role/add" }),
    detail: (data) => request({ data, method: "post", url: "/role/detail" }),
    edit: (data) => request({ data, method: "post", url: "/role/modify" }),
    access: (data) => request({ data, method: "get", url: "/role/access" }),
  },
};
